import { get, put } from '@/services/http';

export interface IBuyingCalendarSettings {
  locationIds: number[];
  supplierFilter: string;
  filterColumns: any[];
  productSegmentId: string | null;
  viewMode: string;
  displayMode: string;
  selectedDimension: string;
  productLimitPerSupplier: number;
}

export const BUYING_CALENDAR_DEFAULTS: IBuyingCalendarSettings = {
  locationIds: [],
  supplierFilter: 'all',
  filterColumns: [],
  productSegmentId: null,
  viewMode: 'week',
  displayMode: 'calendar',
  selectedDimension: 'by_variant',
  productLimitPerSupplier: 100,
};

export class BuyingCalendarSettingsService {
  private static readonly API_PATH = '/settings/buying-calendar';

  public static async get(): Promise<IBuyingCalendarSettings> {
    try {
      const response: any = await get(this.API_PATH);
      if (response.success && response.data) {
        return { ...BUYING_CALENDAR_DEFAULTS, ...response.data };
      }
      return { ...BUYING_CALENDAR_DEFAULTS };
    } catch {
      return { ...BUYING_CALENDAR_DEFAULTS };
    }
  }

  public static async save(settings: IBuyingCalendarSettings): Promise<boolean> {
    try {
      const response: any = await put(this.API_PATH, settings);
      return response.success;
    } catch {
      return false;
    }
  }
}
